import styled from '@emotion/styled';
import type { FC } from 'react';
import { RacemapLogo } from '../BasicComponents/RacemapLogo';
import { VersionLabel } from '../BasicComponents/VersionLabel';

export const LeaderboardFooter: FC = () => {
  return (
    <Container>
      <RacemapLogo height={40} />
      <FooterVersion />
    </Container>
  );
};

const FooterVersion = styled(VersionLabel)`
  padding-right: 15px;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;
